import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {HeaderService} from "../../../services/header/header.service";

@Component({
  selector: 'app-rapport',
  templateUrl: './rapport.component.html',
  styleUrls: ['./rapport.component.scss']
})
export class RapportComponent implements OnInit {
    reportCards: any[] = [
        {
            title: 'Rapport de vente',
            icon: 'shopping-cart',
            color: 'text-blue-500 border-blue-200',
            reports: [
                'Vente par client',
                'Détails ventes par ligne produit',
                'Transactions client',
                'TVA ventes',
                'Total des retenues pour les clients'
            ]
        },
        {
            title: 'Rapport d\'achat',
            icon: 'truck',
            color: 'text-indigo-500 border-indigo-200',
            reports: [
                'Achat par fournisseur',
                'Détails d\'achat par ligne produit',
                'Transactions fournisseurs',
                'TVA achat',
                'Total des retenues pour les fournisseurs'
            ]
        },
        {
            title: 'Rapport stock',
            icon: 'package',
            color: 'text-orange-500 border-orange-200',
            reports: [
                'Mouvement détaillé de stock',
                'État de stock à une date antérieure'
            ]
        },
        {
            title: 'Rapport de paiement',
            icon: 'credit-card',
            color: 'text-green-500 border-green-200',
            reports: [
                'Paiement clients',
                'Paiements fournisseurs',
                'Facture clients payées depuis plus d\'un mois'
            ]
        },
        {
            title: 'Rapport Bénéfices',
            icon: 'trending-up',
            color: 'text-emerald-500 border-emerald-200',
            reports: [
                'Bénéfice commercial par pièce',
                'Bénéfice commercial mensuel',
                'Bénéfice commercial par ligne',
                'Bénéfice commercial par produit'
            ]
        },
        {
            title: 'Rapport client',
            icon: 'users',
            color: 'text-sky-500 border-sky-200',
            reports: [
                'Chiffre d\'affaire par client',
                'Solde client'
            ]
        },
        {
            title: 'Rapport fournisseur',
            icon: 'user-check',
            color: 'text-cyan-500 border-cyan-200',
            reports: [
                'Chiffre d\'affaires par fournisseur',
                'Soldes fournisseur'
            ]
        }
    ];

    constructor(private router: Router, private headerService: HeaderService) {}

    openReport(name: string) {
        this.router.navigate(['/rapport/detail'], { queryParams: { name } });
    }

    ngOnInit() {
        this.headerService.setConfig({
            title: 'Rapport',
            buttons: [
            ]
        });
    }

}
